import { render, staticRenderFns } from "./BetsElement.vue?vue&type=template&id=f65f55ea&scoped=true"
import script from "./BetsElement.vue?vue&type=script&lang=js"
export * from "./BetsElement.vue?vue&type=script&lang=js"
import style0 from "./BetsElement.vue?vue&type=style&index=0&id=f65f55ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65f55ea",
  null
  
)

export default component.exports